import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-search-keyboard-hints',
  standalone: true,
  imports: [],
  templateUrl: './search-keyboard-hints.component.html',
  styleUrl: './search-keyboard-hints.component.scss',
})
export class SearchKeyboardHintsComponent {
  @Output() close = new EventEmitter<void>();
}
